export default "__VITE_ASSET__V3OxuKyh__"